export default {
  layout: {
    default: [
      '1 2 3 4 5 6 7 8 9 0 \' ì {bksp}',
      'q w e r t y u i o p é +',
      'a s d f g h j k l ç à ù',
      '{shift} < z x c v b n m , . - {shift}',
      '@ {space}',
    ],
    shift: [
      '! " £ $ % & / ( ) = ? ^ {bksp}',
      'Q W E R T Y U I O P è *',
      'A S D F G H J K L ò ° §',
      '{shift} > Z X C V B N M ; : _ {shift}',
      '@ {space}',
    ],
  },
};
